module.exports = __webpack_public_path__ + "img/manual-holiday-02b-add-slot-holiday.aad5af1c.png";